export default __webpack_public_path__ + "img/rule_tab-6674ec03.png";